import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import Cell from './Cell';
import Nav from './Nav';
import dayjs from 'dayjs';
import { useSetRecoilState } from 'recoil';
import { calendarSelectdDateState } from '@atom/calendar/calendar';
import { masterSet } from '@masterSetting/masterSet/masterSetting';
import { BOARD_TYPE } from '@typings/boardType';

import { scrollbarHide } from '@styles/variants/scrollbar';
import CalenderList from './CalenderList';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  height: 100%;
  padding: 12px;
`;

const ScrollWrap = styled.div`
  overflow-y: auto;
  padding-top: 2px;
  height: calc(100% - 8px);

  ${scrollbarHide}
`;

const Row = styled.div`
  display: grid;
  height: 100%;
  grid-template-columns: repeat(7, 1fr);
  border-top: 1px solid var(--lineColor);
`;

const daysMap = ['일', '월', '화', '수', '목', '금', '토'];

type Props = {
  onClickCell?: () => void;
};
function MiniCalendar({ onClickCell }: Props) {
  const collectionPath = useMemo(() => {
    const calendarBoard = masterSet.boardSet.find(
      (b) => b.typeName === BOARD_TYPE.CALENDAR,
    );
    return calendarBoard?.path || 'calendar';
  }, []);
  const currentDate = new Date();
  const [focusDate, setFocusDate] = useState<Date | any>(currentDate);
  const [startDay, setStartDay] = useState<number>(0);
  const [endDay, setEndDay] = useState<number>(0);
  const [daysCount, setDaysCount] = useState<number>(0);
  const setSelectedDate = useSetRecoilState(calendarSelectdDateState);

  const emptyStartDays = Array.from({ length: startDay }, (v, i) => v);
  const emptyEndDays = Array.from({ length: 6 - endDay }, (v, i) => v);
  const countDays = Array.from({ length: daysCount }, (v, i) => i + 1);
  const days: number | any = [...emptyStartDays, ...countDays, ...emptyEndDays];

  const handleClickCell = useCallback(
    (day) => {
      if (day) {
        const _selectedDate = dayjs(focusDate).set('date', day); //timestamp
        setSelectedDate(_selectedDate);

        // navigate('calendar');
      }

      if (onClickCell) onClickCell();
    },
    [onClickCell, focusDate],
  );

  useEffect(() => {
    setStartDay(dayjs(focusDate).startOf('month').day());
    setEndDay(dayjs(focusDate).endOf('month').day());
    setDaysCount(dayjs(focusDate).daysInMonth());
  }, [focusDate]);

  return (
    <Container>
      <Nav focusDate={focusDate} setFocusDate={setFocusDate} />

      <Row>
        {daysMap.map((day, index) => (
          <Cell key={index} day={day} index={index} />
        ))}

        {days.map((item, index) => {
          const focusDayStirng =
            dayjs(focusDate).format('YYYY-MM') + '-' + item;
          const currentDayString = dayjs(currentDate).format('YYYY-MM-D');

          return (
            <Cell
              key={index}
              day={item}
              index={index}
              onClickCell={handleClickCell}
              isToday={focusDayStirng === currentDayString}
              cell
            >
              {item && (
                <ScrollWrap>
                  <CalenderList
                    collectionPath={collectionPath}
                    dateQuery={dayjs(focusDate)
                      .set('date', item)
                      .format('YYYY-MM-DD')}
                  />
                </ScrollWrap>
              )}
            </Cell>
          );
        })}
      </Row>
    </Container>
  );
}

export default React.memo(MiniCalendar);
